'use client'

import { show } from '@intercom/messenger-js-sdk'
import { Button } from '@populix/pop-ui'

import { AMP_EVENT_NAME, trackAmpEvent } from '@/libs/configs/amplitude'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import { toggleIntercom } from '@/libs/store/slice/ui-slice'

export default function ButtonContactUsAccountDeletion() {
  const { showIntercom } = useAppSelector((state) => state.ui)
  const dispatch = useAppDispatch()

  const handleShowIntercom = () => {
    if (!showIntercom) {
      show()
      trackAmpEvent(AMP_EVENT_NAME.CLICK_HELP_CENTER, {
        'Page URL': window.location.href,
      })
      return dispatch(toggleIntercom(true))
    }
  }

  return (
    <Button
      type='button'
      variant='contained'
      color='primary'
      onClick={handleShowIntercom}
      aria-label='Contact Us'
    >
      Contact Us
    </Button>
  )
}
